<script setup lang="ts">

import HomeButton from "./HomeButton.vue";
</script>

<template>
  <div class="logo-img">
    <img src="/@/assets/clashmini.webp" alt="" >
  </div>
  <div class="bg-img">
    <img src="/@/assets/KeyArt_landscape.jpg" alt="" >
  </div>
<HomeButton></HomeButton>
</template>

<style scoped lang="scss">
.logo-img {
  display: flex; // 关键：启用 Flexbox
  justify-content: center; // 水平居中
  align-items: center; // 垂直居中
  width: 100%;
  height: 30dvh;
  img {
    width: 35dvh;
    object-fit: contain; // 确保图片按比例缩放
  }
}

.bg-img {
  top: 0;
  left: 0;
  right: 0;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: -10;
  overflow: hidden;
  img {
    position: absolute; /* 让 img 绝对定位 */
    top: 42%;
    left: 50%;
    min-width: 100%;
    height: 100%;
    object-fit: cover; /* 让图片填充并裁剪 */
    transform: translate(-50%, -50%); /* 让图片居中 */
  }

}
</style>
